module.exports = __webpack_public_path__ + "media/images/icon-button-map-favorite-dc4419a33deb9e9c11bc629e395728c5.svg";